import { render } from "./UsecaseItem.vue?vue&type=template&id=04469822&scoped=true&ts=true&lang=pug"
import script from "./UsecaseItem.vue?vue&type=script&lang=ts"
export * from "./UsecaseItem.vue?vue&type=script&lang=ts"

import "./UsecaseItem.vue?vue&type=style&index=0&id=04469822&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04469822"]])

export default __exports__